import CART_ITEM from '../../../../../../../services/checkout/constants/cartItems';

/**
 * Determines if the user can purchase an individual photo
 *
 * @param {Object} options the function props
 * @param {Array} options.cart the current cart
 * @param {Object} options.photoPricing the photo's pricing
 * @param {Array} options.albumPrintPackages the print packages for the viewing gallery
 * @param {Boolean} options.isEntitled whether or not the photo is entitled to the user
 * @returns {boolean|boolean}
 */
export const canPurchaseIndividualPhoto = ({
  cart,
  photoPricing,
  albumPrintPackages,
  isEntitled,
}) => {
  if (!albumPrintPackages?.length || isEntitled) {
    return true;
  }

  const photoPricingRequiresPackage = photoPricing?.requires_package_purchase;
  // As of 2022, ANY package is enough to unlock individual pricing
  // settings. Therefore, photo checking is no longer required here.
  const photoPrintPackageCartItems = cart.filter(
    item =>
      item.type === CART_ITEM.ALBUM_PRINT_PACKAGE &&
      albumPrintPackages
        .map(({ id }) => id)
        .includes(item.albumPrintPackage.id),
  );

  return photoPricingRequiresPackage
    ? photoPrintPackageCartItems.length > 0
    : true;
};

/**
 * Given a matched Photo, extract the set of faceboxes to show.
 *
 * @param {Object} matchedPhoto the matched photo object
 * @param {Boolean} withFallback whether or not to fallback to centered facebox
 * @returns {Array}
 */
export const getFaceboxes = (matchedPhoto, withFallback = false) => {
  const fallback = [[0.25, 0.25, 0.5, 0.5, 0]];

  if (!matchedPhoto) {
    return withFallback ? fallback : [];
  }

  const { compared_face: comparedFace } = matchedPhoto;

  if (comparedFace) {
    return [comparedFace.facebox];
  }

  return withFallback ? fallback : [];
};
